import React, { useState } from "react";
import Avatar from "../Common/Avatar";

const ConversationHeader = ({
  toggleParticipantChatInfo,
  leaveConversation,
  oponentId,
  isgroup,
  oponentName,
  avatar,
}) => {
  //Conversation participant dropdown menu
  const [participantMenu, toggleParticipantMenu] = useState(false);
  // const toggleParticipantDropdown = () =>
  //   toggleParticipantMenu(!participantMenu);

  const showParticipantChatInfo = () => {
    toggleParticipantChatInfo(true);
    // toggleParticipantDropdown();
  };

  return (
    <div className="chat-header">
      <button
        className="btn btn-secondary btn-icon btn-minimal btn-sm text-muted d-xl-none"
        type="button"
        style={{ marginRight: "15px" }}
        onClick={leaveConversation}
      >
        <svg
          className="hw-20"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M10 19l-7-7m0 0l7-7m-7 7h18"
          />
        </svg>
      </button>
      <div className="media chat-name align-items-center text-truncate selected-chat-user">
        {/* <div className="avatar avatar-online d-none d-sm-inline-block mr-3">
          <img src="/media/avatar/2.png" alt="" />
        </div> */}
        <Avatar
          id={oponentId}
          isGroup={isgroup}
          status={false}
          imgPath={avatar}
        />
        <div
          className="media-body align-self-center "
          style={{ paddingLeft: "15px" }}
        >
          <h6 className="text-truncate mb-0">{oponentName}</h6>
          {/* <small className="text-muted">ხაზზეა</small> */}
        </div>
      </div>
      <ul className="nav flex-nowrap">
        <li className="nav-item list-inline-item  d-sm-block mr-0">
          <div className="dropdown">
            <div
              className="nav-link text-muted px-1"
              onClick={showParticipantChatInfo}
              // onClick={toggleParticipantDropdown}
            >
              <svg
                className="hw-20 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              {/* <svg
                className="hw-20"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                />
              </svg> */}
            </div>

            {participantMenu ? (
              <div
                className="dropdown-menu dropdown-menu-right"
                style={{ display: "block" }}
              >
                <div
                  className="dropdown-item align-items-center d-flex"
                  data-chat-info-toggle=""
                  onClick={showParticipantChatInfo}
                >
                  <svg
                    className="hw-20 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <span>დეტალურად</span>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </li>
      </ul>
    </div>
  );
};

export default ConversationHeader;
